import { css } from 'styled-components';
import { getTextStyle } from '../../../content/texts/bou-text/text-style';

export const originalTippyStyling = css`
  &[data-animation='fade'][data-state='hidden'] {
    opacity: 0;
  }
  [data-tippy-root] {
    max-width: calc(100vw - 10px);
  }
  & {
    ${getTextStyle({ size: 'xxs' })}
    position: relative;
    background-color: #333;
    color: #fff;
    border-radius: 4px;
    line-height: 1.4;
    outline: 0;
    transition-property: transform, visibility, opacity;
  }
  &[data-placement^='top'] > .tippy-arrow {
    bottom: 0;
  }
  &[data-placement^='top'] > .tippy-arrow:before {
    bottom: -7px;
    left: 0;
    border-width: 8px 8px 0;
    border-top-color: initial;
    transform-origin: center top;
  }
  &[data-placement^='bottom'] > .tippy-arrow {
    top: 0;
  }
  &[data-placement^='bottom'] > .tippy-arrow:before {
    top: -7px;
    left: 0;
    border-width: 0 8px 8px;
    border-bottom-color: initial;
    transform-origin: center bottom;
  }
  &[data-placement^='left'] > .tippy-arrow {
    right: 0;
  }
  &[data-placement^='left'] > .tippy-arrow:before {
    border-width: 8px 0 8px 8px;
    border-left-color: initial;
    right: -7px;
    transform-origin: center left;
  }
  &[data-placement^='right'] > .tippy-arrow {
    left: 0;
  }
  &[data-placement^='right'] > .tippy-arrow:before {
    left: -7px;
    border-width: 8px 8px 8px 0;
    border-right-color: initial;
    transform-origin: center right;
  }
  &[data-inertia][data-state='visible'] {
    transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);
  }
  .tippy-arrow {
    width: 16px;
    height: 16px;
    color: #333;
  }
  .tippy-arrow:before {
    content: '';
    position: absolute;
    border-color: transparent;
    border-style: solid;
  }
  .tippy-content {
    position: relative;
    padding: 5px 9px;
    z-index: 1;
  }
`;
